"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import GroupCreateConfig from "./config/GroupCreateConfig";
import GroupCreateActions from "./actions/GroupCreateActions";
import GroupCreateHeader from "./GroupCreateHeader";
import GroupCreateName from "./GroupCreateName";
import GroupCreateWrapper from "./GroupCreateWrapper";
import { ApiGroupFilterDirection } from "@/generated/models/ApiGroupFilterDirection";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import { ApiGroupTdhInclusionStrategy } from "@/generated/models/ApiGroupTdhInclusionStrategy";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { commonApiFetch } from "@/services/api/common-api";
import GroupCreateIncludeMeAndPrivate from "./config/include-me-and-private/GroupCreateIncludeMeAndPrivate";
import { AuthContext } from "@/components/auth/Auth";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function GroupCreate(t0) {
  const $ = _c(92);
  const {
    edit,
    onCompleted
  } = t0;
  const isEditMode = !!edit && edit !== "new";
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  let t2;
  if ($[0] !== edit) {
    t1 = [QueryKey.GROUP, edit];
    t2 = async () => await commonApiFetch({
      endpoint: `groups/${edit}`
    });
    $[0] = edit;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = !!edit && isEditMode;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      placeholderData: keepPreviousData,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: originalGroup,
    isFetching: loadingOriginalGroup
  } = useQuery(t4);
  const t5 = originalGroup?.id;
  const t6 = originalGroup?.group.identity_group_id;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = [QueryKey.GROUP_WALLET_GROUP_WALLETS, {
      group_id: t5,
      wallet_group_id: t6
    }];
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== originalGroup?.group || $[11] !== originalGroup?.id) {
    t8 = async () => await commonApiFetch({
      endpoint: `groups/${originalGroup?.id}/identity_groups/${originalGroup?.group.identity_group_id}`
    });
    $[10] = originalGroup?.group;
    $[11] = originalGroup?.id;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !!originalGroup?.id && !!originalGroup?.group.identity_group_id;
  let t10;
  if ($[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = {
      queryKey: t7,
      queryFn: t8,
      enabled: t9
    };
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const {
    data: originalGroupWallets,
    isFetching: loadingOriginalGroupWallets
  } = useQuery(t10);
  const t11 = originalGroup?.id;
  const t12 = originalGroup?.group.excluded_identity_group_id;
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = [QueryKey.GROUP_WALLET_GROUP_WALLETS, {
      group_id: t11,
      wallet_group_id: t12
    }];
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== originalGroup?.group || $[21] !== originalGroup?.id) {
    t14 = async () => await commonApiFetch({
      endpoint: `groups/${originalGroup?.id}/identity_groups/${originalGroup?.group.excluded_identity_group_id}`
    });
    $[20] = originalGroup?.group;
    $[21] = originalGroup?.id;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = !!originalGroup?.id && !!originalGroup?.group.excluded_identity_group_id;
  let t16;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t15) {
    t16 = {
      queryKey: t13,
      queryFn: t14,
      enabled: t15
    };
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const {
    data: originalGroupExcludedWallets,
    isFetching: loadingOriginalGroupExcludedWallets
  } = useQuery(t16);
  const [isFetching, setIsFetching] = useState(loadingOriginalGroup || loadingOriginalGroupWallets || loadingOriginalGroupExcludedWallets);
  let t17;
  let t18;
  if ($[27] !== loadingOriginalGroup || $[28] !== loadingOriginalGroupExcludedWallets || $[29] !== loadingOriginalGroupWallets) {
    t17 = () => {
      setIsFetching(loadingOriginalGroup || loadingOriginalGroupWallets || loadingOriginalGroupExcludedWallets);
    };
    t18 = [loadingOriginalGroup, loadingOriginalGroupWallets, loadingOriginalGroupExcludedWallets];
    $[27] = loadingOriginalGroup;
    $[28] = loadingOriginalGroupExcludedWallets;
    $[29] = loadingOriginalGroupWallets;
    $[30] = t17;
    $[31] = t18;
  } else {
    t17 = $[30];
    t18 = $[31];
  }
  useEffect(t17, t18);
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      name: "",
      group: {
        tdh: {
          min: null,
          max: null,
          inclusion_strategy: ApiGroupTdhInclusionStrategy.Both
        },
        rep: {
          min: null,
          max: null,
          direction: ApiGroupFilterDirection.Received,
          user_identity: null,
          category: null
        },
        cic: {
          min: null,
          max: null,
          direction: ApiGroupFilterDirection.Received,
          user_identity: null
        },
        level: {
          min: null,
          max: null
        },
        owns_nfts: [],
        identity_addresses: null,
        excluded_identity_addresses: null,
        is_beneficiary_of_grant_id: null
      },
      is_private: false
    };
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const [groupConfig, setGroupConfig] = useState(t19);
  const [iAmIncluded, setIAmIncluded] = useState(false);
  let t20;
  let t21;
  if ($[33] !== originalGroup || $[34] !== originalGroupExcludedWallets || $[35] !== originalGroupWallets) {
    t20 = () => {
      if (!originalGroup) {
        return;
      }
      setGroupConfig({
        name: originalGroup.name,
        group: {
          tdh: {
            min: originalGroup.group.tdh?.min,
            max: originalGroup.group.tdh?.max,
            inclusion_strategy: originalGroup.group.tdh?.inclusion_strategy ?? ApiGroupTdhInclusionStrategy.Tdh
          },
          rep: {
            min: originalGroup.group.rep?.min,
            max: originalGroup.group.rep?.max,
            direction: originalGroup.group.rep?.direction,
            user_identity: originalGroup.group.rep?.user_identity,
            category: originalGroup.group.rep?.category
          },
          cic: {
            min: originalGroup.group.cic?.min,
            max: originalGroup.group.cic?.max,
            direction: originalGroup.group.cic?.direction,
            user_identity: originalGroup.group.cic?.user_identity
          },
          level: {
            min: originalGroup.group.level?.min,
            max: originalGroup.group.level?.max
          },
          owns_nfts: originalGroup.group.owns_nfts,
          identity_addresses: originalGroupWallets ?? [],
          excluded_identity_addresses: originalGroupExcludedWallets ?? [],
          is_beneficiary_of_grant_id: originalGroup.group.is_beneficiary_of_grant_id ?? null
        },
        is_private: originalGroup.is_private ?? false
      });
    };
    t21 = [originalGroup, originalGroupWallets, originalGroupExcludedWallets];
    $[33] = originalGroup;
    $[34] = originalGroupExcludedWallets;
    $[35] = originalGroupWallets;
    $[36] = t20;
    $[37] = t21;
  } else {
    t20 = $[36];
    t21 = $[37];
  }
  useEffect(t20, t21);
  let t22;
  if ($[38] !== connectedProfile) {
    t22 = () => {
      if (!connectedProfile) {
        return [];
      }
      return connectedProfile.wallets?.map(_temp) ?? [];
    };
    $[38] = connectedProfile;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const getMyAddresses = t22;
  let t23;
  if ($[40] !== connectedProfile || $[41] !== getMyAddresses || $[42] !== groupConfig) {
    t23 = () => {
      if (!connectedProfile) {
        return;
      }
      const myAddresses = getMyAddresses();
      setIAmIncluded(groupConfig.group.identity_addresses?.some(address => myAddresses.includes(address.toLowerCase())) ?? false);
    };
    $[40] = connectedProfile;
    $[41] = getMyAddresses;
    $[42] = groupConfig;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== connectedProfile || $[45] !== groupConfig) {
    t24 = [connectedProfile, groupConfig];
    $[44] = connectedProfile;
    $[45] = groupConfig;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  useEffect(t23, t24);
  let t25;
  if ($[47] !== connectedProfile?.primary_wallet || $[48] !== connectedProfile?.wallets || $[49] !== groupConfig) {
    t25 = newState => {
      const primaryWallet = connectedProfile?.primary_wallet?.toLowerCase();
      if (newState && !primaryWallet) {
        return;
      }
      setIAmIncluded(newState);
      const consolidatedAddresses = connectedProfile?.wallets?.map(_temp2) ?? [];
      const currentAddresses = groupConfig.group.identity_addresses ?? [];
      const newAddresses = currentAddresses.filter(address_0 => !consolidatedAddresses.includes(address_0.toLowerCase()));
      if (newState && primaryWallet) {
        newAddresses.push(primaryWallet);
      }
      setGroupConfig(prev => ({
        ...prev,
        group: {
          ...prev.group,
          identity_addresses: newAddresses
        }
      }));
    };
    $[47] = connectedProfile?.primary_wallet;
    $[48] = connectedProfile?.wallets;
    $[49] = groupConfig;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  const onSetIAmIncluded = t25;
  if (isFetching) {
    let t26;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <div>Loading...</div>;
      $[51] = t26;
    } else {
      t26 = $[51];
    }
    return t26;
  }
  let t26;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <GroupCreateHeader />;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = name => setGroupConfig(prev_0 => ({
      ...prev_0,
      name
    }));
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== groupConfig.name) {
    t28 = <GroupCreateName name={groupConfig.name} setName={t27} />;
    $[54] = groupConfig.name;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  const t29 = groupConfig.is_private ?? false;
  let t30;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = isPrivate => setGroupConfig(prev_1 => ({
      ...prev_1,
      is_private: isPrivate
    }));
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== iAmIncluded || $[58] !== onSetIAmIncluded || $[59] !== t29) {
    t31 = <GroupCreateIncludeMeAndPrivate isPrivate={t29} iAmIncluded={iAmIncluded} setIsPrivate={t30} setIAmIncluded={onSetIAmIncluded} />;
    $[57] = iAmIncluded;
    $[58] = onSetIAmIncluded;
    $[59] = t29;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t28 || $[62] !== t31) {
    t32 = <div className="tw-space-y-4 sm:tw-space-y-5">{t26}<div className="tw-grid tw-grid-cols-1 tw-gap-6 lg:tw-grid-cols-2">{t28}{t31}</div></div>;
    $[61] = t28;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  let t38;
  let t39;
  let t40;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = level => setGroupConfig(prev_2 => ({
      ...prev_2,
      group: {
        ...prev_2.group,
        level
      }
    }));
    t34 = tdh => setGroupConfig(prev_3 => ({
      ...prev_3,
      group: {
        ...prev_3.group,
        tdh
      }
    }));
    t35 = cic => setGroupConfig(prev_4 => ({
      ...prev_4,
      group: {
        ...prev_4.group,
        cic
      }
    }));
    t36 = rep => setGroupConfig(prev_5 => ({
      ...prev_5,
      group: {
        ...prev_5.group,
        rep
      }
    }));
    t37 = wallets => setGroupConfig(prev_6 => ({
      ...prev_6,
      group: {
        ...prev_6.group,
        identity_addresses: wallets
      }
    }));
    t38 = wallets_0 => setGroupConfig(prev_7 => ({
      ...prev_7,
      group: {
        ...prev_7.group,
        excluded_identity_addresses: wallets_0
      }
    }));
    t39 = nfts => setGroupConfig(prev_8 => ({
      ...prev_8,
      group: {
        ...prev_8.group,
        owns_nfts: nfts
      }
    }));
    t40 = grantId => setGroupConfig(prev_9 => ({
      ...prev_9,
      group: {
        ...prev_9.group,
        is_beneficiary_of_grant_id: grantId ?? null
      }
    }));
    $[64] = t33;
    $[65] = t34;
    $[66] = t35;
    $[67] = t36;
    $[68] = t37;
    $[69] = t38;
    $[70] = t39;
    $[71] = t40;
  } else {
    t33 = $[64];
    t34 = $[65];
    t35 = $[66];
    t36 = $[67];
    t37 = $[68];
    t38 = $[69];
    t39 = $[70];
    t40 = $[71];
  }
  let t41;
  if ($[72] !== groupConfig.group.cic || $[73] !== groupConfig.group.excluded_identity_addresses || $[74] !== groupConfig.group.identity_addresses || $[75] !== groupConfig.group.is_beneficiary_of_grant_id || $[76] !== groupConfig.group.level || $[77] !== groupConfig.group.owns_nfts || $[78] !== groupConfig.group.rep || $[79] !== groupConfig.group.tdh || $[80] !== iAmIncluded) {
    t41 = <GroupCreateConfig level={groupConfig.group.level} tdh={groupConfig.group.tdh} cic={groupConfig.group.cic} rep={groupConfig.group.rep} wallets={groupConfig.group.identity_addresses} excludeWallets={groupConfig.group.excluded_identity_addresses} nfts={groupConfig.group.owns_nfts} beneficiaryGrantId={groupConfig.group.is_beneficiary_of_grant_id} iAmIncluded={iAmIncluded} setLevel={t33} setTDH={t34} setCIC={t35} setRep={t36} setWallets={t37} setExcludeWallets={t38} setNfts={t39} setBeneficiaryGrantId={t40} />;
    $[72] = groupConfig.group.cic;
    $[73] = groupConfig.group.excluded_identity_addresses;
    $[74] = groupConfig.group.identity_addresses;
    $[75] = groupConfig.group.is_beneficiary_of_grant_id;
    $[76] = groupConfig.group.level;
    $[77] = groupConfig.group.owns_nfts;
    $[78] = groupConfig.group.rep;
    $[79] = groupConfig.group.tdh;
    $[80] = iAmIncluded;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  const t42 = originalGroup ?? null;
  let t43;
  if ($[82] !== groupConfig || $[83] !== onCompleted || $[84] !== t42) {
    t43 = <GroupCreateActions originalGroup={t42} groupConfig={groupConfig} onCompleted={onCompleted} />;
    $[82] = groupConfig;
    $[83] = onCompleted;
    $[84] = t42;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  let t44;
  if ($[86] !== t41 || $[87] !== t43) {
    t44 = <div className="tw-space-y-5"><div>{t41}{t43}</div></div>;
    $[86] = t41;
    $[87] = t43;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  let t45;
  if ($[89] !== t32 || $[90] !== t44) {
    t45 = <GroupCreateWrapper><div className="tw-flex tw-flex-col tw-gap-y-6 sm:tw-gap-y-8">{t32}{t44}</div></GroupCreateWrapper>;
    $[89] = t32;
    $[90] = t44;
    $[91] = t45;
  } else {
    t45 = $[91];
  }
  return t45;
}
function _temp2(w_0) {
  return w_0.wallet.toLowerCase();
}
function _temp(w) {
  return w.wallet.toLowerCase();
}